<h5 mat-dialog-title>Tu perfil</h5>
<mat-divider></mat-divider>
<div mat-dialog-content>
  <div class="text-center mb-4">
    <ng-container *ngIf="infoHelper.getPhotoProfileUser() !== ''; else letterLogo">
      <div class="user-avatar rounded-circle border border-5 border-alternative mb-4">
          <app-image [image]="infoHelper.getPhotoProfileUser()" classImage="img-fluid rounded-circle user-avatar-pic"></app-image>            
      </div>        
    </ng-container>
    <ng-template #letterLogo>
        <app-image [fullName]="infoHelper.getFullname()"></app-image>
    </ng-template>
    <div class="badge-bottom"></div>
    <h4 class="text-primary-emphasis fw-bold">{{infoHelper.getFullname()}}</h4>
    <p class="fs-5">{{infoHelper.getProfile()}}</p>
  </div>
  <div class="row justify-content-between g-4 pb-3">
    <div class="col-12 col-md-6 col-lg-4 text-center border-end">
      <h6 class="text-secondary fw-normal">Fecha de Nacimiento</h6>
      <span class="fs-6 fw-bold">15/08/1993</span>
    </div>
    <div class="col-12 col-md-6 col-lg-4 text-center border-end">
      <h6 class="text-secondary fw-normal">Organización</h6>
      <span class="fs-6 fw-bold">{{infoHelper.getOrganization()}}</span>
    </div>
    <div class="col-12 col-md-6 col-lg-4 text-center">
      <h6 class="text-secondary fw-normal">Sucursal</h6>
      <span class="fs-6 fw-bold">{{infoHelper.getBranchOffice()}}</span>
    </div>
    <div class="col-12 col-md-6 col-lg-4 text-center border-end">
      <h6 class="text-secondary fw-normal">Módulo</h6>
      <span class="fs-6 fw-bold">Hospitalización</span>
    </div>
    <div class="col-12 col-md-6 col-lg-4 text-center border-end">
      <h6 class="text-secondary fw-normal">Especialidad</h6>
      <span class="fs-6 fw-bold">Pediatría</span>
    </div>
    <div class="col-12 col-md-6 col-lg-4 text-center">
      <h6 class="text-secondary fw-normal">Cédula de la Especialidad</h6>
      <span class="fs-6 fw-bold">xxxxx</span>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions class="float-end">
    <button mat-stroked-button color="primary" (click)="onClose()">Cerrar</button>
  </div>
</div>